module.exports = __webpack_public_path__ + "img/nomber_ukr.41eeaf08.png";